import { supabase } from './supabaseClient';
import { useResponsesStore } from '../stores/Responses';

export const saveResponse = async (response: any, allResponses: any) => {
    const hash = allResponses.find((r) => r.id === 'hash')?.value;
    if (!hash) return;

    const db_id = allResponses.find((r) => r.id === 'db_id')?.value;
    if (!db_id) await saveEnquiry(hash);

    const row = {
        enquiry: hash,
        question: response.id,
        value: response.value,
    };

    const { data, error } = await supabase
        .from('responses')
        .upsert(row, { onConflict: ['enquiry', 'question'] });

    if (error) {
        console.error('Error saving response', error);
    }
}

export const saveEnquiry = async (hash: any) => {
    const row = {
        hash: hash,
    }

    const { data, error } = await supabase
        .from('enquiries')
        .upsert(row, { onConflict: ['hash'] })
        .select();

    if (error) {
        console.error('Error saving enquiry', error);
        return null
    }

    if (data) {
        // add db_id as a response
        const { addResponse } = useResponsesStore.getState();
        addResponse({ id: 'db_id', value: data[0].id });
    }
}

export const setCompletedDate = async (hash: any) => {
    const row = {
        hash: hash,
        submit_datetime: new Date(),
    }

    const { data, error } = await supabase
        .from('enquiries')
        .upsert(row, { onConflict: ['hash'] });

    if (error) {
        console.error('Error saving completed date', error);
    }
}

export const saveAppliances = async (hash: string, appliances: any[]) => {
    // Step 1: Delete all existing appliances for the given enquiry hash
    const { error: deleteError } = await supabase
        .from('appliances')
        .delete()
        .eq('enquiry', hash);

    if (deleteError) {
        console.error('Error deleting existing appliances:', deleteError);
        return;
    }

    if (!appliances) return;

    // Step 2: Prepare new rows for insertion
    const rows = appliances.map((appliance) => ({
        enquiry: hash,
        appliance: appliance.name,
        voltage: appliance.volts,
        wattage: appliance.consumption,
        quantity: appliance.quantity,
        usage: appliance.hours,
        offgrid: appliance.offgrid,
    }));

    // Step 3: Insert new appliances
    const { data, error: insertError } = await supabase
        .from('appliances')
        .insert(rows);

    if (insertError) {
        console.error('Error saving new appliances:', insertError);
    } else {
        console.log('Successfully saved appliances:', data);
    }
};